export default [{
        path: '/portefeuilles/contrats',
        name: 'contrats-list',
        component: () => import('@/views/portefeuilles/contrats/Lists.vue'),
    },
    {
        path: '/portefeuilles/reclamations',
        name: 'reclamations-list',
        component: () => import('@/views/portefeuilles/reclamations/Lists.vue'),
    },
    {
        path: '/portefeuilles/sinistres',
        name: 'sinistres-list',
        component: () => import('@/views/portefeuilles/sinistres/Lists.vue'),
    },
]